import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, map, take } from 'rxjs';

import {
  getCurrentUser,
  getUserRole,
} from '../store/auth-state/auth.selectors';

import {
  DashboardRole,
  getDashboardRoute,
  normalizeDashboardRole,
} from '../utils/dashboard-role.util';

export const dashboardRoleGuard: CanActivateFn = route => {
  const store = inject(Store);
  const router = inject(Router);

  const allowedRoles =
    (route.data?.['roles'] as DashboardRole[] | undefined) ?? [];

  return combineLatest({
    role: store.select(getUserRole),
    currentUser: store.select(getCurrentUser),
  }).pipe(
    take(1),
    map(({ role, currentUser }) => {
      const directRole = normalizeDashboardRole(role);

      const originRole = normalizeDashboardRole(
        currentUser?.roles?.[0]?.origin_created_by
      );

      const resolvedRole = directRole ?? originRole;

      if (!resolvedRole) {
        return router.createUrlTree(['/forbidden']);
      }

      if (allowedRoles.includes(resolvedRole)) {
        return true;
      }

      // Wrong role-specific URL: send the user to their own dashboard.
      return router.parseUrl(
        getDashboardRoute(resolvedRole)
      );
    })
  );
};